/**
 * Espera a que la cola de subida de PowerSync (`ps_crud`) se VACÍE.
 *
 * Costura local-first → REST (F4-D): cuando un flujo escribe por el write-path
 * (sync) e inmediatamente llama a un endpoint REST que LEE esas filas en el
 * server (p.ej. añadir franjas de horario → "generar sesiones"), el REST puede
 * adelantarse a la subida y ver un estado vacío. Este helper drena la cola
 * antes del REST para que el server vea lo que el usuario ve.
 *
 * Devuelve `true` si la cola quedó vacía dentro del plazo; `false` si expiró
 * (offline, backend caído…). El caller decide si seguir igualmente — el
 * endpoint sigue siendo la autoridad.
 */
import type { AbstractPowerSyncDatabase } from "@powersync/web";

const POLL_INTERVAL_MS = 150;

export async function waitForUploadQueueDrain(
  ps: AbstractPowerSyncDatabase,
  timeoutMs = 10_000,
): Promise<boolean> {
  const deadline = Date.now() + timeoutMs;
  for (;;) {
    const rows = await ps.getAll<{ pending: number }>(
      // eslint-disable-next-line lingui/no-unlocalized-strings -- SQL, no UI
      "SELECT count(*) AS pending FROM ps_crud",
    );
    if ((rows[0]?.pending ?? 0) === 0) {
      return true;
    }
    if (Date.now() >= deadline) {
      return false;
    }
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS));
  }
}
